import React from 'react';
import SubView from 'components/main/pages/home/views/SubView';

import CreateOrJoin from './CreateOrJoin';
import GroupMemberRow from 'components/main/items/rows/GroupMemberRow';

class StudentGroup extends SubView {

  constructor(props){
    super(props);
    this.init(props);
    this.getStudentProfiles();
    this.group = this.func.getById.joinedGroupByProject(this.store.projects.viewingProject._id, this.store);
    if(this.group && !this.store.groups.data[this.group._id]){
      this.actions.groups.fetchGroupData(this.group);
    }
  }

  getStudentProfiles(){
    const course = this.store.courses.viewingCourse;
    const profilesToGet = [];
    const profilesToShow = course.joinedStudents;
    for(var i=0;i<profilesToShow.length;i++){
      if(this.func.getById.profileByUser(profilesToShow[i], this.store) === null){
        profilesToGet.splice(0,0, profilesToShow[i]);
      }
    }
    if(profilesToGet.length > 0){
      this.actions.profiles.getProfiles(profilesToGet);
    }
  }

  memberRows(group){
    return group.members.map((member, i)=>{
      if(member === group.leader){ return null; }
      return <GroupMemberRow key={i} app={this.app} userId={member}/>
    })
  }

  render(){
    this.init(this.props);

    const group = this.group;
    if(!group){ return <CreateOrJoin app={this.app}/> }

    if(!this.store.groups.data[group._id]){ return null; }

    return(
      <div style={{...this.subViewStyle(), ...{width: "100%", overflowY:"initial"}}}>
        {this.gap('5%')}

        {this.subTitle(['Group name','小組名稱','小组名称'])}
        {this.sep()}
        {this.textDisplay(group.name)}
        {this.gap('4%')}

        {this.subTitle(['Leader','組長','组长'])}
        {this.sep()}
        <GroupMemberRow app={this.app} userId={group.leader}/>
        {this.gap('4%')}

        {this.subTitle(['Members','組員','组员'])}
        {this.sep()}
        {this.memberRows(group)}
        {this.gap('4%')}
        {this.group.createdByTeacher !== true &&  this.subTitle(['Code','代碼','代码'])}
        {this.group.createdByTeacher !== true && this.sep()}
        {this.group.createdByTeacher !== true && this.textDisplay(group.code)}
        {this.group.createdByTeacher !== true && this.gap('4%')}
        {this.group.createdByTeacher !== true &&  this.buttons.rectRed(['Leave group','退出小組','退出小组'],
        ()=>{this.actions.modal.confirm(['Confirm to leave group?','確定退出小組?','确定退出小组?'], ()=>{
          //this.actions.groups.changeGroupLeader(, code);
            this.actions.groups.leaveGroup(
              this.store.user._id,
              group.code
            );
          })}
        )}
        {this.group.createdByTeacher !== true && this.gap('6%')}
      </div>
    )
  }
}

export default StudentGroup;
